import { Header } from "../components/Header";
import { HeroSection } from "../components/HeroSection";
import { AboutSection } from "../components/AboutSection";
import { RestaurantSection } from "../components/RestaurantSection";
import { MenuSection } from "../components/MenuSection";
import { LodgingSection } from "../components/LodgingSection";
import { BookingForm } from "../components/BookingForm";
import { GallerySection } from "../components/GallerySection";
import { ContactSection } from "../components/ContactSection";
import { Footer } from "../components/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <RestaurantSection />
        <MenuSection />
        <LodgingSection />
        <BookingForm />
        <GallerySection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
